import React from "react";
import "./Dashboard.css";
import {ENABLE_FIA_FLOW, EVENTS, PAGES, STORAGE_KEYS} from "../../scripts/constants";
import {Container, Row, Col, Button, Tabs, Tab} from "react-bootstrap";
import LiveChat from 'react-livechat';
import {LiveChatInfo} from '../../scripts/live-chat';
import {mygaSession} from "../../scripts/myga-session";
import Carousel from "react-multi-carousel";
import {
  loadMygaRates,
  loadTreasuryRates,
  loadBankRates,
  loadProductRates,
  loadMygaProductRates
} from "../../scripts/myga-data";
import MygaRateBarChart from "../Dashboard/ResearchCenter/Charts/MygaRateBarChart";
import TreasuryNotesLineChart from "../Dashboard/ResearchCenter/Charts/TreasuryNotesLineChart";
import TreasuryBillsLineChart from "../Dashboard/ResearchCenter/Charts/TreasuryBillsLineChart";
import AppPageHeader from "../Application/AppPageHeader/AppPageHeader";
import MYGA_STRINGS from "../../Resources/Content/MYGAStrings";
import PopoverTooltip from "../../components/PopoverTooltip";
import {deleteApp, getShoppingCart} from "../../scripts/sync-manager";
import Resources from "../../Resources/Resources";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import TrustBoxContainer, {TRUST_PILOT_TEMPLATE, TRUST_PILOT_THEME} from "../../components/TrustPilot";
import {NassauLog} from "../../scripts/myga-utils";
import NassauAlert from "../../components/NassauAlert/NassauAlert";
import {
  MM_PRODUCT, MM_PRODUCT_DTO,
  MM_PRODUCT_FAMILY,
  MM_PRODUCT_ID,
  MM_PRODUCT_TYPE,
  MM_PRODUCT_VISUALS
} from "../../scripts/myga-model";
import {productForId, validateRateForProductDTO} from "../../scripts/product-manager";
import CONFIG from "../../temp/config"

const findSixYear = d => d.find( rate => rate.years === '6'  );
const findFourYear = d => d.find( rate => rate.years === '4' );

class Dashboard extends React.Component {
  
  cdInstitution = 'Capital One';
  headerStyles = {
    backgroundColor: 'rgba(242, 193, 102, 0.25)',
    width: '100%',
    fontSize: '1.5em',
    marginTop: '20px'
  };
  subHeaderStyles = {
    fontSize: '1.3em'
  };
  responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  carouselItemStyles = {
    height: '250px',
    marginLeft: '10px',
    marginRight: '10px'
  };
  
  constructor(props) {
    super(props);
    this.state = {
      showChat: !CONFIG.testing,
      rateAlertMessage: '',
      gotoPageAfterAlertClose: null,
      userEmail: null,
      rate4yr: null,
      rate6yr: null,
      shoppingCart: null,
      submissions: null,
      mygaProductRates: null,
      mygaProductRatesTab: null,
      mygaRates: null,
      bankRates: null,
      treasuryRates: null,
      summaryRates: {
        billRates: {
          issueDate: '',
          twentySixWeek: {
            label: '26-Week Bill',
            rate: ''
          },
          eightWeek: {
            label: '8-Week Bill',
            rate: ''
          }
        },
        noteRates: {
          issueDate: '',
          sevenYear: {
            label: '7-Year Note',
            rate: ''
          },
          tenYear: {
            label: '10-Year Note',
            rate: ''
          }
        },
        cdRates: {
          issueDate: '',
          fourYear: {
            label: '4-Year',
            institution: this.cdInstitution,
            rate: ''
          },
          threeYear: {
            label: '3-Year',
            institution: this.cdInstitution,
            rate: ''
          },
          twoYear: {
            label: '2-Year',
            institution: this.cdInstitution,
            rate: ''
          },
          oneYear: {
            label: '1-Year',
            institution: this.cdInstitution,
            rate: ''
          },
          sixMonth: {
            label: '6-Month',
            institution: this.cdInstitution,
            rate: ''
          }
        },
        mmRates: {
          issueDate: '',
          label: '',
          rate: ''
        }
      }
    }
  }
  
  componentDidMount() {
    
    //I dont think we want this to load up the current app anymore,
    //in fact, we should clear it now. They will use the Apply for new,
    //and the line item to continue
    let app = mygaSession.getCurrentApp();
    if (app) {
      this.setState({userEmail: app.userEmail});
      NassauLog("AgentInfo: " + JSON.stringify(mygaSession.getAgentInfo()));
    }
    
    // Add event listener to check for session clear from nav bar.
    mygaSession.eventEmitter.on(EVENTS.sessionCleared, () => this.setState({shoppingCart: null, submissions: null}));
    
    getShoppingCart()
        .then(data=> {
          NassauLog("Dashboard:// shopping cart: " + JSON.stringify(data.shoppingCart,null,2));
          NassauLog("Dashboard:// submissions: " + JSON.stringify(data.submissions,null,2));
          
          // 2021.09.23.ADivelbiss - need a way to get the email from the any application
          let newState = {
            shoppingCart: data.shoppingCart,
            submissions: data.submissions,
          };
          // NassauLog(`this.state: ${JSON.stringify(this.state,null,2)}`);
          if (!this.state.userEmail && data.shoppingCart.length>0) {
            newState.userEmail = data.shoppingCart[0].userEmail;
          }
          if (!this.state.userEmail && data.submissions.length>0) {
            newState.userEmail = data.submissions[0].userEmail;
          }
          // NassauLog(`newState: ${JSON.stringify(newState,null,2)}`);
          this.setState(newState);
        })
        .catch((err)=>{
          NassauLog(err);
        });
    
    const currentMygaRates = mygaSession.getMygaRates();
    
    loadMygaRates()
        .then(data=> {
          // NassauLog("Dashboard:// myga rates: " + JSON.stringify(data));
          
          
          //Lets get our rate and make it available
          let sixYear = findSixYear(data);
          let rate6yr = parseFloat(sixYear.rate).toFixed(2)+"%";
          
          let fourYear = findFourYear(data);
          let rate4yr = parseFloat(fourYear.rate).toFixed(2)+"%";
          
          let newState = {mygaRates: data, rate6yr, rate4yr};
          
          if (currentMygaRates) {
            let curSixYear = findSixYear(currentMygaRates);
            let curFourYear = findFourYear(currentMygaRates);
            if (sixYear.rate !== curSixYear.rate || fourYear.rate !== curFourYear.rate) {
              newState.rateAlertMessage = Resources.Strings.Dashboard_RateChangeMessage;
            }
          }
          
          this.setState(newState)
        })
        .catch((err)=>{
          NassauLog(err);
        });
    
    // 2022.05.12.ADivelbiss - load the new rates files for simple an myannuity
    this.loadDataForQuoteWidget();
    
    loadBankRates()
        .then(data=> {
          // NassauLog("Dashboard:// bank rates: " + JSON.stringify(data));
          const findDuration = (rates, duration) => rates.find(i => i.duration === duration);
          const findInstitution = (rates, institution) => rates.find(i => i.institution === institution);
          let institutionData = findInstitution(data.cdRates, this.cdInstitution);
          
          let summaryData = this.state.summaryRates;
          summaryData.cdRates.issueDate = data.effectiveDate;
          summaryData.cdRates.fourYear.rate = findDuration(institutionData.rates, '4y').rate + '%';
          summaryData.cdRates.threeYear.rate = findDuration(institutionData.rates, '3y').rate + '%';
          summaryData.cdRates.twoYear.rate = findDuration(institutionData.rates, '2y').rate + '%';
          summaryData.cdRates.oneYear.rate = findDuration(institutionData.rates, '1y').rate + '%';
          summaryData.cdRates.sixMonth.rate = findDuration(institutionData.rates, '6m').rate + '%';
          
          let mmData = findInstitution(data.moneyMarketRates, this.cdInstitution);
          summaryData.mmRates.issueDate = data.effectiveDate;
          summaryData.mmRates.label = mmData.account;
          summaryData.mmRates.rate = mmData.rate + '%';
          this.setState({bankRates: data, ...summaryData});
        })
        .catch((err)=>{
          NassauLog(err);
        });
    
    loadTreasuryRates()
        .then(data=> {
          // NassauLog("Dashboard:// treasury rates: " + JSON.stringify(data));
          
          let week26Bill = data.billRates.find(item => item.term === '26-Week');
          let week8Bill = data.billRates.find(item => item.term === '8-Week');
          let sevenYearNote = data.noteRates.find(item => item.term === '7-Year');
          let tenYearNote = data.noteRates.find(item => item.term === '10-Year');
          
          let dateFormat = date => new Date(date).toLocaleDateString("en-US", {year: 'numeric', month: 'numeric', day: 'numeric'});
          
          let summaryData = this.state.summaryRates;
          summaryData.billRates.issueDate = dateFormat(week26Bill.issueDate);
          summaryData.billRates.twentySixWeek.rate = parseFloat(week26Bill.highDiscountRate).toFixed(2) + '%';
          summaryData.billRates.eightWeek.rate = parseFloat(week8Bill.highDiscountRate).toFixed(2) + '%';
          summaryData.noteRates.issueDate = dateFormat(sevenYearNote.issueDate);
          summaryData.noteRates.sevenYear.rate = parseFloat(sevenYearNote.highYield).toFixed(2) + '%';
          summaryData.noteRates.tenYear.rate = parseFloat(tenYearNote.highYield).toFixed(2) + '%';
          this.setState({treasuryRates: data, ...summaryData});
        })
        .catch((err)=>{
          NassauLog(err);
        });
  };
  
  componentWillUnmount() {
    mygaSession.eventEmitter.off(EVENTS.sessionCleared);
  }
  
  loadDataForQuoteWidget = () => {
    this.setState({
      mygaProductRates: null,
      mygaProductRatesTab: null
    });
    loadMygaProductRates()
        .then(data=>{
          // NassauLog(`mygaRates: ${JSON.stringify(data,null,2)}`);
          // convert the data into a format for display
          // tabs will be surrender charge period
          const mygaProductRates = Object.keys(MM_PRODUCT_FAMILY).reduce((pval,productFamily)=>{
            const val = {...pval};
            // get the first group
            const group = data[productFamily].rates[0];
            // get the columns with "Year" in the id
            const columns = group.columns.filter(col=>col.id.includes("Year"));
            // for each year column create an object with an array of fwa objects
            columns.forEach(col=> {
              let fwa = val[col.id] || [];
              group.accounts.forEach(acc=>{
                let fwaValue = acc.fwa.substring(0,acc.fwa.length-1);
                fwaValue = fwaValue.length>1 ? fwaValue : `0${fwaValue}`;
                fwa.push({
                  "fwa": acc.fwa,
                  "rate": acc[col.id],
                  "productFamily":productFamily,
                  "productId": `${productFamily}0${col.id[0]}${fwaValue}`
                })
              });
              val[col.id] = fwa;
            });
            return val;
          },{});
          NassauLog(`mygaProductRates: ${JSON.stringify(mygaProductRates,null,2)}`);
          this.setState({
            "mygaProductRates": mygaProductRates,
            "mygaProductRatesTab": Object.keys(mygaProductRates).sort()[0]
          });
        })
        .catch(err=>NassauLog(err));
  }
  
  /**
   * Start or continue an application
   * @param application - the application or null
   */
  startApplication = (application = null, productType = MM_PRODUCT_TYPE.myga) => {
    // Initialize the current application default is null
    mygaSession.setCurrentApp(application);
    
    // If after setting the application there is an existing product then use its productType
    // Othewise use the provided productType
    if (mygaSession.getCurrentAppProductDTOs().length>0) {
      productType = mygaSession.getCurrentAppProductDTOs()[0][MM_PRODUCT_DTO.productType];
    }
    
    // Set the product type for the proper page flow
    mygaSession.setMygaSessionValue(STORAGE_KEYS.CurrentProductType, productType);
    
    // check to see if the application rates have changed
    let showRateModal = (application!==null) &&
        mygaSession.getCurrentAppProductDTOs().reduce((value,dto)=>{
          return value || validateRateForProductDTO(dto)!==0;
        },false);
    
    if (showRateModal) {
      this.setState({
        rateAlertMessage: Resources.Strings.Dashboard_ApplicationRateChangeMessage,
        gotoPageAfterAlertClose: PAGES.pageGuestEmail
      });
    } else {
      // 20210714.ADivelbiss - start with the guest email page always
      this.pageBtnClicked(PAGES.pageGuestEmail);
    }
    
  }
  
  handleAlertClose = () => {
    this.setState({rateAlertMessage: ''})
    if (this.state.gotoPageAfterAlertClose) {
      this.pageBtnClicked(this.state.gotoPageAfterAlertClose);
    }
    
  };
  
  pageBtnClicked = (nextPage) => {
    
    // check to see if we have a guest principal saved
    if (!Object.values(PAGES.dashboardFullPages).find(item => item === nextPage)) {
      
      if (nextPage===PAGES.pageGuestEmail || mygaSession.getShowGuestEmailPage()) {
        // TODO: Show the full registration page.  For now show guest
        this.props.updatePage(PAGES.pageGuestEmail);
        // } else if (nextPage===PAGES.pageAgentCode || mygaSession.getShowAgentPage()) {
        //   this.props.updatePage(PAGES.pageAgentCode);
      } else {
        this.props.updatePage(nextPage);
      }
      
    } else {
      this.props.updatePage(nextPage);
    }
    
  };
  
  renderShoppingCart = () => {
    // NassauLog(`renderShoppingCart - this.state: ${JSON.stringify(this.state,null,2)}`);
    if (this.state.userEmail) {
      return (
          //Shopping Cart - Aka Not Submitted
          (this.state.shoppingCart || []).map((item, index) => {
            return (
                <Row className={'pb-1'} key={index}>
                  <Col>
                    <Row>
                      <Col>{item.appStatus}</Col>
                      <Col>{item.startDate}</Col>
                      <Col>
                        <Button variant={'primary'}
                                className={'p-1'}
                                size={'sm'}
                                onClick={() => {
                                  this.startApplication(item);
                                }}>Continue
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
            )
          })
      
      )
    }
  };
  
  renderApplications = () => {
    if (this.state.userEmail) {
      return (
          //Submissions
          (this.state.submissions || []).map((item, index) => {
            return (
                <Row className={'pb-1'} key={index}>
                  <Col>
                    <Row>
                      <Col>Submitted</Col>
                      <Col>{item.startDate}</Col>
                      <Col><Button variant={'primary'}
                                   disabled
                                   className={'p-1'}
                                   size={'sm'}
                      >Call for Info
                      </Button></Col>
                    </Row>
                  </Col>
                </Row>
            )
          })
      
      )
    }
  };
  
  renderNoApplications = () => {
    
    if ((this.state.shoppingCart || []).length === 0) {
      
      return (
          <div>You have no pending applications.  <i onClick={() => {
            
            //Clear out existing app to start a new one.
            mygaSession.setCurrentApp(null);
            // 20210714.ADivelbiss - start with the guest email page always
            this.pageBtnClicked(PAGES.pageGuestEmail);
            // this.pageBtnClicked(PAGES.pageAppProcessOverview)
            
          }} style={{cursor: 'pointer'}}>Click to begin.</i></div>
      )
    }
  };
  
  renderTrustpilotReviews = () => {
    
    return (
        
        //We use different templates based on device size, we intend to only show one of these at a time
        <div>
          
          {/* Show Slider On Small (Width) Devices */}
          <div
              className={'d-block d-sm-none'}>
            <TrustBoxContainer
                tpTemplate={TRUST_PILOT_TEMPLATE.Carousel}
                tpTheme={TRUST_PILOT_THEME.light}
                tpHeight={'320px'}
                tpWidth={'100%'}
            />
          </div>
          
          {/* Show Carousel On Medium (Width) Devices */}
          <div
              className={'d-none d-sm-block d-lg-none'}>
            <TrustBoxContainer
                tpTemplate={TRUST_PILOT_TEMPLATE.Carousel}
                tpTheme={TRUST_PILOT_THEME.light}
                tpHeight={'140px'}
                tpWidth={'100%'}
            />
          </div>
          
          {/* Show Grid on Larger Than Medium (Width) Devices */}
          <div
              className={'d-none d-lg-block'}>
            <TrustBoxContainer
                tpTemplate={TRUST_PILOT_TEMPLATE.Grid}
                tpTheme={TRUST_PILOT_THEME.light}
                tpHeight={'500px'}
                tpWidth={'100%'}
            />
          </div>
        
        </div>
    
    );
    
  };
  
  renderMygaRatesWidget = () => {
    try {
      return (
          <Row className={'text-center'}>
            <Col className="rates-apply dark">
              {
                this.state.mygaProductRatesTab ? (
                    <Tabs
                        fill justify
                        activeKey={this.state.mygaProductRatesTab}
                        onSelect={(eventKey)=>{
                          this.setState({
                            mygaProductRatesTab: eventKey
                          })
                        }}
                    >
                      {
                        Object.keys(this.state.mygaProductRates).sort().map((rateKey,index)=>{
                          const tabInfo = this.state.mygaProductRates[rateKey][0];
                          const product = productForId(tabInfo.productId);
                          const visuals = product[MM_PRODUCT.visuals];
                          return(
                              <Tab key={index} eventKey={rateKey} title={rateKey}>
                                {/* Product Name */}
                                <Row className="dashboard-row text-center">
                                  <Col className="font-page-larger">
                                    <span className={'dashboard-sub-header'}>{visuals[MM_PRODUCT_VISUALS.title]}<sup>{visuals[MM_PRODUCT_VISUALS.tradeMark]}</sup></span>
                                    <PopoverTooltip content={visuals[MM_PRODUCT_VISUALS.info]}/>
                                  </Col>
                                </Row>
                                {/* Column Headers */}
                                <Row className="dashboard-row pt-0 text-center">
                                  <Col>
                                    Free Withdrawal
                                  </Col>
                                  <Col>
                                    Rate
                                  </Col>
                                </Row>
                            
                                {/* rows */}
                                {
                                  this.state.mygaProductRates[rateKey].map(info=>{
                                    return (
                                        <Row className="dashboard-row text-center">
                                          <Col>
                                            {info.fwa}
                                          </Col>
                                          <Col>
                                            {info.rate}
                                          </Col>
                                        </Row>
                                    )
                                  })
                                }
                              </Tab>
                          )
                        })
                      }
                    </Tabs>
                ) : (
                    <Row className="dashboard-row text-center">
                      <Col className="font-page-larger">
                        <span className={'dashboard-sub-header'}>Loading MYGA Rates...</span>
                      </Col>
                    </Row>
                )
              }
            </Col>
          </Row>
      );
    }
    catch (e) {
      this.loadDataForQuoteWidget();
    }
    return (
        <Row className="dashboard-row text-center">
          <Col className="font-page-larger">
            <span className={'dashboard-sub-header'}>Loading MYGA Rates...</span>
          </Col>
        </Row>
    );
  }
  
  render() {
    
    return (
        <Container id={'dashboard'} className="page-area">
          <div className={'page-content-area dashboard-page'} align={'center'}>
            <Container fluid style={{padding: '0'}}>
              {/* MGYA Rates*/}
              <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelTodaysRates} headerInfo={MYGA_STRINGS.Dashboard_InfoNassauMygaInfo}/>
              {this.renderMygaRatesWidget()}
              
              {/* HANDLE FIA */}
              {ENABLE_FIA_FLOW && (
                  <>
                    {/* FIA Rates*/}
                    <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelTodaysRatesFIA} headerInfo={'TODO: Add FIA Info'}/>
                    {/* NGA */}
                    <Row className={'text-center'}>
                      <Col className="rates-apply">
                        <Row className="dashboard-row text-center">
                          <Col className="font-page-larger">
                            <span className={'dashboard-sub-header'}>Nassau Growth Annuity</span>
                            <PopoverTooltip content={'TODO: NGA Info'}/>
                          </Col>
                        </Row>
                        <Row className="text-center pb-1">
                          <Col>
                            TODO: NGA Information.
                          </Col>
                        </Row>
                        <Row className={'dashboard-row text-center'}>
                          <Col>
                            <a href={'https://salesnet.nfg.com/nassau-growth-annuity.html'} target={'_blank'}>View the latest rates in your state.</a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {/* PIA */}
                    <Row className={'text-center'}>
                      <Col className="rates-apply">
                        <Row className="dashboard-row text-center">
                          <Col className="font-page-larger">
                            <span className={'dashboard-sub-header'}>Nassau Personal Income Annuity</span>
                            <PopoverTooltip content={'TODO: PIA Info'}/>
                          </Col>
                        </Row>
                        <Row className="text-center pb-1">
                          <Col>
                            TODO: PIA Information.
                          </Col>
                        </Row>
                        <Row className={'dashboard-row text-center'}>
                          <Col>
                            <a href={'https://salesnet.nfg.com/personal-income-annuity.html'} target={'_blank'}>View the latest rates in your state.</a>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {/* FIA apply button */}
                    <Row className={'text-center pb-4'}>
                      <Col>
                        <Button id={'btn-fia-apply'} variant={'primary'} className={'nsre-button test-enabled'}
                                onClick={() => {
                          
                                  //Clear out the current app before starting a new one
                                  mygaSession.setCurrentApp(null);
                                  // 20210714.ADivelbiss - start with the guest email page always
                                  this.pageBtnClicked(PAGES.pageGuestEmail);
                                  // this.pageBtnClicked(PAGES.pageAppProcessOverview);
                          
                                }}>
                          APPLY
                        </Button>
                      </Col>
                    </Row>
                  </>
              )}
              
              {/*  Applications  */}
              <Row>
                <Col className={'px-0'}>
                  <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelShoppingCart}/>
                  {/* MYGA Apply button*/}
                  <Row className={'text-center pb-2 pt-2'}>
                    <Col>
                      <Button id={'btn-myga-apply'} variant={'primary'} className={'nsre-button test-enabled'}
                              onClick={() => {
                                //Clear out the current app before starting a new one
                                mygaSession.setCurrentApp(null);
                                // 20210714.ADivelbiss - start with the guest email page always
                                this.pageBtnClicked(PAGES.pageGuestEmail);
                                // this.pageBtnClicked(PAGES.pageAppProcessOverview);
        
                              }}>
                        APPLY
                      </Button>
                    </Col>
                  </Row>
                  <div style={{padding: '10px'}}>
                    {this.renderShoppingCart()}
                    {this.renderApplications()}
                    {this.renderNoApplications()}
                  </div>
                </Col>
              </Row>
              
              {/*  Messages  */}
              <Row>
                <Col className={'px-0'}>
                  <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelMessages}/>
                  <div style={{padding: '10px'}}>
                    You have no messages.
                  </div>
                </Col>
              </Row>
              
              {/*  Charts  */}
              <Row>
                <Col className={'px-0'}>
                  <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelResearch}/>
                  <div style={{position: 'relative', padding: '10px', cursor: 'pointer'}}
                       onClick={() => this.pageBtnClicked(PAGES.dashboardFullPages.pageRateCharts)}>
                    
                    <Carousel
                        responsive={this.responsive}
                        containerClass={'carousel-container'}
                        autoPlay
                        autoPlaySpeed={4000}
                        infinite
                        arrows={false}
                    >
                      {/* 2025.12.23.ADivelbiss - commented since bankRates are not being updated. */}
                      {/*<div style={this.carouselItemStyles}>*/}
                      {/*  <MygaRateBarChart mygaData={this.state.mygaRates} bankData={this.state.bankRates} />*/}
                      {/*</div>*/}
                      <div style={this.carouselItemStyles}>
                        <TreasuryNotesLineChart
                            data={this.state.treasuryRates}
                            duration={'7-Year'}
                            title={'Treasury Note (7-Year)'}/>
                      </div>
                      <div style={this.carouselItemStyles}>
                        <TreasuryNotesLineChart
                            data={this.state.treasuryRates}
                            duration={'5-Year'}
                            title={'Treasury Note (5-Year)'}/>
                      </div>
                      <div style={this.carouselItemStyles}>
                        <TreasuryBillsLineChart
                            data={this.state.treasuryRates}
                            duration={'26-Week'}
                            title={'Treasury Bill (26-Week)'}/>
                      </div>
                      <div style={this.carouselItemStyles}>
                        <TreasuryBillsLineChart
                            data={this.state.treasuryRates}
                            duration={'13-Week'}
                            title={'Treasury Bill (13-Week)'}/>
                      </div>
                    </Carousel>
                  </div>
                </Col>
              </Row>
              
              {/*  Trustpilot Reviews  */}
              <Row>
                <Col className={'px-0 py-1'}>
                  <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelCustomerReviews}/>
                  {
                    this.renderTrustpilotReviews()
                  }
                </Col>
              </Row>
              
              <AppPageHeader headerLabel={MYGA_STRINGS.Dashboard_SectionLabelAlternatives}/>
              
              <Row>
                <Col className={'col-12 col-sm-6 noselect cursorPointer'}
                     onClick={() => this.pageBtnClicked(PAGES.dashboardFullPages.pageTreasuryBillRateList)}>
                  <div style={this.subHeaderStyles}>
                    <span className={'dashboard-sub-header'}>Treasury Bills</span>
                    <PopoverTooltip content={MYGA_STRINGS.Dashboard_InfoAlternatives}/>
                  </div>
                  <div className={'col-12'} style={{display: 'flex'}}>
                    <div className={'col-6'}>{this.state.summaryRates.billRates.eightWeek.label}</div>
                    <div className={'col-6'}>{this.state.summaryRates.billRates.eightWeek.rate}</div>
                  </div>
                  <div className={'col-12'} style={{display: 'flex'}}>
                    <div className={'col-6'}>{this.state.summaryRates.billRates.twentySixWeek.label}</div>
                    <div className={'col-6'}>{this.state.summaryRates.billRates.twentySixWeek.rate}</div>
                  </div>
                  <i className={'alt-disclaimer'}>Source: U.S. Treasury - Issue Date {this.state.summaryRates.billRates.issueDate}</i>
                </Col>
                
                <Col className={'col-12 col-sm-6 noselect cursorPointer'}
                     onClick={() => this.pageBtnClicked(PAGES.dashboardFullPages.pageTreasuryNoteRateList)}>
                  <div style={this.subHeaderStyles}>
                    <span className={'dashboard-sub-header'}>Treasury Notes</span>
                    <PopoverTooltip content={MYGA_STRINGS.Dashboard_InfoAlternatives}/>
                  </div>
                  <div className={'col-12'} style={{display: 'flex'}}>
                    <div className={'col-6'}>{this.state.summaryRates.noteRates.sevenYear.label}</div>
                    <div className={'col-6'}>{this.state.summaryRates.noteRates.sevenYear.rate}</div>
                  </div>
                  <div className={'col-12'} style={{display: 'flex'}}>
                    <div className={'col-6'}>{this.state.summaryRates.noteRates.tenYear.label}</div>
                    <div className={'col-6'}>{this.state.summaryRates.noteRates.tenYear.rate}</div>
                  </div>
                  <i className={'alt-disclaimer'}>Source: U.S. Treasury - Issue Date {this.state.summaryRates.noteRates.issueDate}</i>
                </Col>
                
                {/* 2025.12.23.ADivelbiss - commented since cdRates are not being updated. */}
                {/*<Col className={'col-12 col-sm-6 noselect cursorPointer'}*/}
                {/*     onClick={() => this.pageBtnClicked(PAGES.dashboardFullPages.pageBankCDRateList)}>*/}
                {/*  <div style={this.subHeaderStyles}>*/}
                {/*    <span className={'dashboard-sub-header'}>Bank CDs</span>*/}
                {/*    <PopoverTooltip content={MYGA_STRINGS.LegalInfo_CDs}/>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-4'}>{this.state.summaryRates.cdRates.fourYear.label}</div>*/}
                {/*    <div className={'col-5'}>{this.state.summaryRates.cdRates.fourYear.institution}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.cdRates.fourYear.rate}</div>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-4'}>{this.state.summaryRates.cdRates.threeYear.label}</div>*/}
                {/*    <div className={'col-5'}>{this.state.summaryRates.cdRates.threeYear.institution}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.cdRates.threeYear.rate}</div>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-4'}>{this.state.summaryRates.cdRates.twoYear.label}</div>*/}
                {/*    <div className={'col-5'}>{this.state.summaryRates.cdRates.twoYear.institution}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.cdRates.twoYear.rate}</div>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-4'}>{this.state.summaryRates.cdRates.oneYear.label}</div>*/}
                {/*    <div className={'col-5'}>{this.state.summaryRates.cdRates.oneYear.institution}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.cdRates.oneYear.rate}</div>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-4'}>{this.state.summaryRates.cdRates.sixMonth.label}</div>*/}
                {/*    <div className={'col-5'}>{this.state.summaryRates.cdRates.sixMonth.institution}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.cdRates.sixMonth.rate}</div>*/}
                {/*  </div>*/}
                {/*  <i className={'alt-disclaimer'}>Rates updated on {this.state.summaryRates.cdRates.issueDate}</i>*/}
                {/*</Col>*/}
                
                {/* 2025.12.23.ADivelbiss - commented since cdRates are not being updated. */}
                {/*<Col className={'col-12 col-sm-6'}*/}
                {/*     onClick={() => this.pageBtnClicked(PAGES.dashboardFullPages.pageMoneyMarketRateList)}>*/}
                {/*  <div style={this.subHeaderStyles}>*/}
                {/*    <span className={'dashboard-sub-header'}>Money Market</span>*/}
                {/*    <PopoverTooltip content={MYGA_STRINGS.LegalInfo_MoneyMarket}/>*/}
                {/*  </div>*/}
                {/*  <div className={'col-12'} style={{display: 'flex'}}>*/}
                {/*    <div className={'col-9'}>{this.state.summaryRates.mmRates.label}</div>*/}
                {/*    <div className={'col-3'}>{this.state.summaryRates.mmRates.rate}</div>*/}
                {/*  </div>*/}
                {/*  <i className={'alt-disclaimer'}>Rates updated on {this.state.summaryRates.mmRates.issueDate}</i>*/}
                {/*</Col>*/}
              </Row>
              
              <Row style={{marginTop: '2em', paddingLeft: '15px', paddingRight: '15px'}}>
                <Col className={'disclaimer'}>
                  <div style={{whiteSpace: 'pre-wrap'}}>
                    {/* 2022.07.22.ADivelbiss - new legal text has styling so can't use a string.*/}
                    {/*{MYGA_STRINGS.LegalInfo_AllTheLegalText}*/}
                    {/*  2022.07.22.ADivelbiss - new legal text*/}
                    <p>About Our Company and Product</p>
                    <p className={'font-weight-bold'}>Nassau Simple Annuity and Nassau MYAnnuity are subject to state approval. Product features, options and availability may vary by state. Lifetime payments and guarantees are based on the financial strength and claims-paying ability of Nassau Life and Annuity Company.</p>
                    <p>The information on this website is not a recommendation. It is intended for use by the general public and is not individualized to address any specific investment objective. It is not intended as investment or financial advice. We do not provide tax, financial or investment advice, or act as a fiduciary in the sale or service of the product. Consult a tax advisor or financial representative about your specific circumstances.</p>
                    <p>Annuities are long-term insurance contracts. Annuities held within qualified plans do not provide any additional tax benefit. Early withdrawals during the contract term that exceed any free withdrawal amount (if applicable) will be subject to surrender charges and a market value adjustment. All or a portion of amounts withdrawn are subject to ordinary income tax, and if taken prior to age 59 1⁄2, a 10% IRS penalty may also apply.</p>
                    <p>Applications are subject to Nassau approval. If your application, required forms and premium are not in good order at the time of application signature, you may receive a different guaranteed interest rate for the guarantee period elected on the application. If you renew into a guarantee period of the same duration, the guaranteed interest rate may not be the same as the previous guarantee period. Nassau reserves the right to revise declared rates at any time.</p>
                    <p>The information on this website is a brief description of Nassau Simple Annuity and Nassau MYAnnuity and is meant for informational purposes only. Please refer to your Product Disclosures and/or Contract for any other specific information including limitations, exclusions and charges.</p>
                    <p>Nassau Simple Annuity (18FADTCP and ICC18FADTCP) and Nassau MYAnnuity (18IFDAP and ICC18IFDAP/ICC18IFDANP) are issued by Nassau Life and Annuity Company (Hartford, CT). Nassau Life and Annuity Company is not authorized to conduct business in ME and NY, but that is subject to change. Nassau Life and Annuity Company is a subsidiary of Nassau Financial Group.</p>
                    <p className={'font-weight-bold'}>Insurance Products: NOT FDIC or NCUAA Insured | NO Bank or Credit Union Guarantee.</p>
                  </div>
                </Col>
              </Row>
              <Row style={{marginBottom: '2em', paddingLeft: '15px', paddingRight: '15px'}}>
                <Col className={'disclaimer'}><p>BPD40456</p></Col>
                <Col className={'disclaimer text-right'}><p>©2022 Nassau</p></Col>
              </Row>
            </Container>
          </div>
          
          {
              this.state.showChat && (
                  <LiveChat license={LiveChatInfo.license} group={LiveChatInfo.group}/>
              )
          }
          
          <NassauAlert showAlert={this.state.rateAlertMessage!==''}
                       handleClose={this.handleAlertClose}
                       title={'Rates Updated'}
                       message={this.state.rateAlertMessage}/>
        </Container>
    
    
    );
    
  }
}

export default Dashboard;